import React, { useState } from 'react';
import { API_BASE_URL } from '../../config';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const CreateContest: React.FC = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    contest_name: '',
    contest_date: '',
    result_date: '',
    registration_opens_at: '',
    reward: '',
    reward_worth: '',
    entry_fee: '',
    total_slots: 5000,
    no_of_questions: 20,
    time_for_answer: 900,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE_URL}/admin/create-contest`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('adminToken')}`,
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (!res.ok) {
        Swal.fire('Error', data.error || 'Failed to create contest.', 'error');
        return;
      }

      Swal.fire('Success', 'Contest created successfully!', 'success');
      navigate('/admin/dashboard');
    } catch (err) {
      Swal.fire('Error', 'Server error. Try again later.', 'error');
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-12 bg-white p-8 rounded-xl shadow-lg">
      <h2 className="text-3xl font-bold text-center text-indigo-700 mb-6">Create New Contest</h2>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* Contest Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Contest Name</label>
          <input
            type="text"
            name="contest_name"
            required
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Contest Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Contest Date</label>
          <input
            type="datetime-local"
            name="contest_date"
            required
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Result Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Result Date</label>
          <input
            type="datetime-local"
            name="result_date"
            required
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Registration Opens */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Registration Opens At</label>
          <input
            type="datetime-local"
            name="registration_opens_at"
            required
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Reward */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Reward</label>
          <input
            type="text"
            name="reward"
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Reward Worth */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Reward Worth (₹)</label>
          <input
            type="number"
            name="reward_worth"
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Entry Fee */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Entry Fee</label>
          <input
            type="text"
            name="entry_fee"
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Total Slots */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Total Slots</label>
          <input
            type="number"
            name="total_slots"
            value={form.total_slots}
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* No. of Questions */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">No. of Questions</label>
          <input
            type="number"
            name="no_of_questions"
            value={form.no_of_questions}
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Time per Contest */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Time per Contest (seconds)</label>
          <input
            type="number"
            name="time_for_answer"
            value={form.time_for_answer}
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Submit Button */}
        <div className="sm:col-span-2 mt-4">
          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-3 rounded font-semibold hover:bg-indigo-700 transition"
          >
            Create Contest
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateContest;
